import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react';
import TitleView from "../../../components/atoms/TitleView/TitleView";
import ClienteColumna from "../../../components/molecules/ClienteColumna/ClienteColumna";
import ModalRutaMapa from "../../../components/molecules/ModalRutaMapa/ModalRutaMapa";
import './ServiciosEnVivo.scss';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import { getTurnosEnGeneral } from '../../programacion/Esquemas/EsquemasIntegracion';
import { Dropdown } from 'primereact/dropdown';
import { Button } from '@mui/material';
import { getServiciosEnVivo, getTurnosTodo } from './integracion';

const ServiciosEnVivo = () => {
    // Estado para el filtro
    const [filtro, setFiltro] = useState('');
    const [filtroZona, setFiltroZona] = useState([]);
    const [turnos, setTurnos] = useState([]);
    const [turno, setTurno] = useState({name:'TODOS LOS TURNOS', code:-1});
    const [modalAbierto, setModalAbierto] = useState(false);
    const [rutaSeleccionada, setRutaSeleccionada] = useState(null);
    const intervalRef = useRef(null);
    
    // Opciones de zonas para el MultiSelect
    const zonasOptions = [
        { label: 'Zona A', value: 'A' },
        { label: 'Zona B', value: 'B' },
        { label: 'Zona C', value: 'C' }
    ];
    // Datos de ejemplo - reemplazar con datos reales de tu API
    const [clientesData, setClientesData] = useState([

    ]);
    useEffect(() => {
        getTurnosTodo().then((response) => {
            setTurnos(response?.data);
        });
    }, []);
    // Actualizar cada 10 segundos si está en proceso
    useEffect(() => {
        intervalRef.current = setInterval(() => {
            getServicios()
        }, 10000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);
    useEffect(() => {
        if (turno && turno.code) {
            getServicios()
        }
    }, [turno]);

    const getServicios = async () => {
        if (turno && turno.code) {
            getServiciosEnVivo(turno.code).then((response) => {
                console.log("Servicios en vivo:", response?.data);
                // Aquí puedes actualizar el estado con los datos recibidos
                setClientesData(response?.data);
            });
        }
    }

    const clientesFiltrados = useMemo(() => {
        let filtrados = clientesData || [];

        // Filtrar por zona (si hay zonas seleccionadas)
        if (filtroZona.length > 0) {
            filtrados = filtrados.filter(clienteObj => {
                const zona = clienteObj.rutas[0]?.zona?.toUpperCase();
                return filtroZona.includes(zona);
            });
        }

        // Filtrar por texto
        if (filtro?.trim()) {
            const filtroLower = filtro.toLowerCase()?.trim();
            filtrados = filtrados.filter(clienteObj => {
                // Obtener el nombre del cliente (puede ser string o array)
                const nombreCliente = Array.isArray(clienteObj.cliente)
                    ? clienteObj.cliente[0]
                    : clienteObj.cliente;

                // Filtrar por nombre de cliente
                const coincideCliente = nombreCliente.toLowerCase().includes(filtroLower);

                // Filtrar por nombre de ruta
                const coincideRuta = clienteObj.rutas.some(ruta =>
                    ruta.nombre.toLowerCase().includes(filtroLower)
                );

                // Buscar siempre en ambos
                return coincideCliente || coincideRuta;
            });
        }

        return filtrados;
    }, [clientesData, filtro, filtroZona]);

    // Manejo del click en una card
    const handleCardClick = useCallback((clienteObj) => {
        console.log('Card clickeada:', clienteObj);
        // Aquí puedes agregar lógica adicional como abrir un modal, etc.
    }, []);

    // Manejo del click en una ruta
    const handleRutaClick = useCallback((ruta, nombreCliente, clienteId) => {
        console.log('Ruta clickeada:', ruta);
        setRutaSeleccionada({
            ...ruta,
            nombreCliente,
            clienteId
        });
        setModalAbierto(true);
    }, []);

    // Cerrar modal
    const handleCerrarModal = useCallback(() => {
        setModalAbierto(false);
        setRutaSeleccionada(null);
    }, []);

    return (
        <div className="servicios-en-vivo">
            {/* <TitleView title="Servicios en Vivo" /> */}

            {/* Panel de filtros */}
            <div className="controles-panel">
                <div className="filtros-container">
                    <div className="filtro-busqueda">
                        <InputText
                            type="text"
                            placeholder="Buscar por cliente o ruta..."
                            value={filtro}
                            onChange={(e) => setFiltro(e.target.value)}
                            className="input-busqueda"
                        />
                        <Dropdown 
                            optionLabel='name' 
                            options={turnos} 
                            onChange={(e) => setTurno(e.value)} 
                            value={turno} 
                            placeholder="Selecciona un turno" 
                        />
                        <MultiSelect
                            value={filtroZona}
                            onChange={(e) => setFiltroZona(e.value)}
                            options={zonasOptions}
                            optionLabel="label"
                            placeholder="Filtrar por zonas"
                            className="multiselect-zonas"
                            display="chip"
                            maxSelectedLabels={3}
                        />
                        <Button variant="contained" color="primary" onClick={() => { getServicios() }}>Buscar</Button>
                    </div>
                </div>
            </div>

            {/* Scroll horizontal con columnas */}
            <div className="columnas-scroll-container">
                {!turno || !turno.code ? (
                    <div className="sin-seleccion">
                        <div className="sin-seleccion-icono">📅</div>
                        <h3>Selecciona un turno para comenzar</h3>
                        <p>Por favor, selecciona un turno en el selector de arriba y presiona "Buscar" para ver los servicios en vivo</p>
                    </div>
                ) : clientesFiltrados?.length > 0 ? (
                    <div className="columnas-grid">
                        {clientesFiltrados.map((clienteObj) => (
                            <ClienteColumna
                                key={clienteObj.id}
                                cliente={clienteObj.cliente}
                                rutas={clienteObj.rutas}
                                onRutaClick={handleRutaClick}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="sin-resultados">
                        <div className="sin-resultados-icono">🔍</div>
                        <p>No se encontraron resultados para "{filtro}"</p>
                        <button
                            className="btn-limpiar-filtro"
                            onClick={() => setFiltro('')}
                        >
                            Limpiar filtro
                        </button>
                    </div>
                )}
            </div>

            {/* Modal de ruta con mapa */}
            <ModalRutaMapa
                isOpen={modalAbierto}
                onClose={handleCerrarModal}
                rutaData={rutaSeleccionada}
                idBitacora={rutaSeleccionada?.bitacora}
            />
        </div>
    );
};

export default ServiciosEnVivo;